<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section class="events" id="events">
            <header><h4>{{pubCountData.length > 0 ? pubCountData[0].total_publications : null}}+ Publications of the Faculty as at {{myDate | date:'yyyy-MM-dd' }}</h4></header>
            <h5>{{publicationArea}}</h5>
            <br>

            <div *ngIf="publicationData.length == 0 && pubAreaId != undefined">
              <h4>No publications...</h4>
            </div>

            <!-- at the home page-->
            <div *ngIf="pubAreaId == undefined">
              <div class="section-content news-small">
                <article *ngFor="let item of pubCountData.length > 0 ? pubCountData[0].publication_areas : null">
                  <header>
                    <a routerLink="/research/{{item.id}}">
                      <span class="fa fa-book"></span>
                      {{item.pub_area}} -  {{item.publications}} researches
                    </a>
                  </header>

                </article><!-- /article -->
              </div><!-- /.section-content -->
            </div>

            <!--CSS Loader-->
            <section *ngIf="citeLoader">
              <div class="ph-item" *ngFor="let x of citeRepat">
                <div>
                  <div class="ph-row">
                    <div class="ph-col-12"></div>
                    <div class="ph-col-12"></div>
                    <div class="ph-col-10"></div>
                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-2"></div>
                    <div class="ph-col-10 empty"></div>
                  </div>
                </div>
              </div>
            </section>
            <!--CSS Loader-->

            <div class="section-content">
              <article class="event" *ngFor="let pub of publicationData
              ">
                <figure class="date date-color">
                  <div class="month">{{ pub.year }}</div>

                </figure>
                <aside>
                  <header *ngIf="pub.external_link !== null">
                    <a href="{{pub.external_link}}" target="_blank">
                      <div [innerHTML]="pub.citation"></div>
                    </a>
                  </header>
                  <header *ngIf="pub.external_link === null">
                      <div [innerHTML]="pub.citation"></div>
                  </header>

                  <div class="additional-info">
                    <span> <span class="fa fa-calendar"></span> {{ pub.year }}</span> |
                    <span> <span class="fa fa-file-text"></span> {{ pub.type_name }}</span> |
                    <span>

                      <a routerLink="/staff/{{pub.staff.profile_name}}">
                          {{ pub.staff.title }}. {{ pub.staff.full_name }}
                        <span class="fa fa-user"></span>
                      </a>

                    </span>
                  </div>
                </aside>
              </article><!-- /article -->
            </div><!-- /.section-content -->
          </section><!-- /.events -->
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->
      <!--SIDEBAR Content-->
      <div>

      </div>
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <div *ngIf="pubAreaId == null">
            <img src="assets/img/publication.jpg">
          </div>

          <div *ngIf="pubAreaId != null">
            <aside class="news-small" id="news-small">
              <header>
                <h3>Research Statistics</h3>
              </header>
              <div class="section-content">
                <article *ngFor="let item of pubCountData[0]?.publication_areas">
                    <header>
                      <a routerLink="/research/{{item.id}}" (click)='showPubArea(item.pub_area,item.publications)'>
                        <span class="fa fa-book" ></span>
                        {{item.pub_area}} -  {{item.publications}} researches
                      </a>
                    </header>
                </article><!-- /article -->
              </div><!-- /.section-content -->
            </aside><!-- /.news-small -->
          </div>
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
